/**
 * KAN-764: выбор дней недели - 7 чекбоксов Пн..Вс.
 *
 * Значение - отсортированный список ISO-дней (1=пн..7=вс). Проверку "хотя бы
 * один день" делает форма-владелец (текст ошибки: WEEKDAYS_REQUIRED_ERROR).
 */
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { WEEKDAYS } from '@/lib/weekdays';

interface WeekdaysPickerProps {
  /** Префикс id чекбоксов, уникальный на странице. */
  idPrefix: string;
  value: number[];
  onChange: (days: number[]) => void;
  disabled?: boolean;
  testId?: string;
}

export function WeekdaysPicker({
  idPrefix,
  value,
  onChange,
  disabled = false,
  testId,
}: WeekdaysPickerProps): JSX.Element {
  const toggle = (day: number, checked: boolean): void => {
    const rest = value.filter((d) => d !== day);
    const next = checked ? [...rest, day] : rest;
    onChange(next.sort((a, b) => a - b));
  };

  return (
    <div data-testid={testId} className="flex flex-wrap gap-3" role="group">
      {WEEKDAYS.map(({ day, label }) => {
        const id = `${idPrefix}-day-${day}`;
        return (
          <div key={day} className="flex items-center gap-1.5">
            <Checkbox
              id={id}
              checked={value.includes(day)}
              onCheckedChange={(checked) => toggle(day, checked)}
              disabled={disabled}
            />
            <Label htmlFor={id} className="font-normal">
              {label}
            </Label>
          </div>
        );
      })}
    </div>
  );
}
